import { withStyles } from "@material-ui/styles";
import cx from "classnames";

const styles = theme => ({
  expansionContainer: {
    boxShadow: "0px 0px 0px rgba(216, 216, 216, 0.4)",
    borderRadius: "4px",
    marginBottom: "0.6rem",
    border: "1px solid #E9ECF5",
    backgroundColor: "#ffffff",
    ["&::before"]: {
      backgroundColor: "#ffffff",
      top: 0
    },
    ["@media (min-width:510px)"]: {
      marginBottom: "0.8rem",
      padding: "0 13px",
      borderRadius: "6px"
    }
  },
  expansionPanelSummary: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    userSelect: "none",
    padding: "0 20px",
    justifyContent: "space-between",
    ["@media (min-width:510px)"]: {
      padding: "0 20px 0 30px"
    }
  },
  text: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#171928",
    margin: "20px 12px 20px 0",
    ["@media (min-width:510px)"]: {
      margin: "30px 12px 30px 0"
    }
  },
  greyText: {
    ...theme.typography.faqFont,
    marginBottom: "5px",
    "& p": {
      margin: "0 0 5px 0",
      padding: "0",
      wordBreak: "break-word"
    },
    "& ul": {
      padding: "0 30px",
      margin: "10px 0"
    },
    "& br": {
      marginBottom: "10px"
    },
    "& a": {
      color: "#2A89F6",
      cursor: "pointer",
      textDecoration: "none",
      outline: "none"
    }
  },
  active: {
    boxShadow: "0px 2px 8px rgba(216, 216, 216, 0.4)"
  },
  faqArrowImgClass: {
    transform: "rotate(180deg)",
    transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    outline: "none",
    userSelect: "none",
    width: "24px"
  },
  faqArrowImgClassExpanded: {
    transform: "rotate(0deg)"
  },
  colapsePanelDetails: {
    height: 0,
    overflow: "hidden",
    visibility: "hidden"
  },
  expandPanelDetails: {
    height: "auto",
    display: "flex",
    padding: "0 20px 20px 20px",
    marginTop: "-10px",
    visibility: "visible",
    overflow: "visible",
    ["@media (min-width:510px)"]: {
      padding: "0 20px 30px 30px"
    }
  },
  textExpandedMargins: {
    margin: "8px 12px 8px 0"
  },
  pnl: {
    fontSize: "14px",
    minWidth: "630px",
    ["@media (max-width:570px)"]: {
      minWidth: "auto"
    }
  }
});

const CustomAccordion = props => {
  const { summary, details, expanded, onChange, classes } = props;
  const faqContainerClass = expanded
    ? cx(classes.active, classes.expansionContainer)
    : classes.expansionContainer;
  const panelDtlsClass = expanded
    ? cx(classes.expandPanelDetails, classes.colapsePanelDetails, classes.pnl)
    : cx(classes.colapsePanelDetails, classes.pnl);
  const faqArrowClass = expanded
    ? cx(classes.faqArrowImgClass, classes.faqArrowImgClassExpanded)
    : classes.faqArrowImgClass;

  return (
    <>
      <div
        className={faqContainerClass}
        itemScope
        itemProp="mainEntity"
        itemType="https://schema.org/Question"
      >
        <div className={classes.expansionPanelSummary} onClick={onChange}>
          <span
            className={classes.text}
            itemProp="name"
            dangerouslySetInnerHTML={{ __html: summary }}
          />
          <img
            src="/hire/arrow_up.svg"
            height={8}
            width={12}
            alt="faq"
            className={faqArrowClass}
          />
        </div>
        <div
          className={panelDtlsClass}
          itemScope
          itemProp="acceptedAnswer"
          itemType="https://schema.org/Answer"
        >
          <span
            className={cx(classes.greyText)}
            itemProp="text"
            dangerouslySetInnerHTML={{ __html: details }}
          />
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(CustomAccordion);
